module.exports = require("./gsw.d.ts");